import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/general/max-black.svg'


const _hoisted_1 = { class: "filters-container mb-3 bg-greyLight rounded-md overflow-hidden" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = { class: "p-3 pt-0 overflow-hidden" }
const _hoisted_4 = { class: "grid grid-cols-1 gap-3" }
const _hoisted_5 = { class: "min-w-0" }
const _hoisted_6 = { class: "min-w-0" }
const _hoisted_7 = {
  key: 0,
  "data-cy": "notificationList",
  class: "mt-1"
}
const _hoisted_8 = { class: "flex items-start justify-between" }
const _hoisted_9 = { class: "w-[60%]" }
const _hoisted_10 = { class: "text-lg overflow-x-auto" }
const _hoisted_11 = { class: "text-sm" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { class: "flex flex-col items-center" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 2 }
const _hoisted_20 = { class: "text-sm mt-1" }
const _hoisted_21 = { class: "absolute bottom-1 right-4 text-xs" }
const _hoisted_22 = {
  key: 1,
  class: "text-center text-xl"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PullRefresh = _resolveComponent("PullRefresh")!
  const _component_confirm_modal = _resolveComponent("confirm-modal")!
  const _component_status_modal = _resolveComponent("status-modal")!
  const _component_notification_page_skeleton = _resolveComponent("notification-page-skeleton")!
  const _component_standart_template = _resolveComponent("standart-template")!

  return (_openBlock(), _createBlock(_component_standart_template, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "flex items-center justify-between p-3 cursor-pointer",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.filtersExpanded = !_ctx.filtersExpanded))
        }, [
          _cache[26] || (_cache[26] = _createElementVNode("div", { class: "text-sm font-semibold" }, "Фильтры", -1)),
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(), _createElementBlock("svg", {
              class: _normalizeClass([{ 'rotate-180': _ctx.filtersExpanded }, "w-4 h-4 transition-transform"]),
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [...(_cache[25] || (_cache[25] = [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M19 9l-7 7-7-7"
              }, null, -1)
            ]))], 2))
          ])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[27] || (_cache[27] = _createElementVNode("label", { class: "text-xs text-gray-600" }, "Дата от", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "date",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filtersDatetimeFrom) = $event)),
                class: "w-full p-2 text-sm border rounded mt-1 min-w-0 box-border appearance-none",
                onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)))
              }, null, 544), [
                [_vModelText, _ctx.filtersDatetimeFrom]
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[28] || (_cache[28] = _createElementVNode("label", { class: "text-xs text-gray-600" }, "Дата до", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "date",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filtersDatetimeTo) = $event)),
                class: "w-full p-2 text-sm border rounded mt-1 min-w-0 box-border appearance-none",
                onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)))
              }, null, 544), [
                [_vModelText, _ctx.filtersDatetimeTo]
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[29] || (_cache[29] = _createElementVNode("label", { class: "text-xs text-gray-600" }, "Номер карты", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters.card_suffix) = $event)),
                maxlength: "4",
                placeholder: "Последние 4 цифры",
                class: "w-full p-2 text-sm border rounded mt-1",
                onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)))
              }, null, 544), [
                [_vModelText, _ctx.filters.card_suffix]
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[31] || (_cache[31] = _createElementVNode("label", { class: "text-xs text-gray-600" }, "Статус", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filters.status) = $event)),
                class: "w-full p-2 text-sm border rounded mt-1",
                onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)))
              }, [...(_cache[30] || (_cache[30] = [
                _createElementVNode("option", { value: null }, "Все статусы", -1),
                _createElementVNode("option", { value: "PAID" }, "Успешно", -1),
                _createElementVNode("option", { value: "IN_PROCESSING" }, "В обработке", -1),
                _createElementVNode("option", { value: "ERROR" }, "Ошибка", -1),
                _createElementVNode("option", { value: "REVERTED" }, "Возвращено", -1)
              ]))], 544), [
                [_vModelSelect, _ctx.filters.status]
              ])
            ])
          ]),
          (_ctx.hasActiveFilters)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.resetFilters && _ctx.resetFilters(...args))),
                class: "mt-3 w-full py-2 text-sm bg-blue text-white rounded-lg"
              }, " Сбросить фильтры "))
            : _createCommentVNode("", true)
        ], 512), [
          [_vShow, _ctx.filtersExpanded]
        ])
      ]),
      (!_ctx.isAtTop)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.scrollToTop && _ctx.scrollToTop(...args))),
            class: "fixed bottom-24 right-4 w-12 h-12 rounded-full bg-blue text-white flex items-center justify-center shadow-lg z-50"
          }, [...(_cache[32] || (_cache[32] = [
            _createElementVNode("svg", {
              class: "w-6 h-6",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M5 15l7-7 7 7"
              })
            ], -1)
          ]))]))
        : _createCommentVNode("", true),
      _createVNode(_component_PullRefresh, {
        modelValue: _ctx.reloadLoading,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.reloadLoading) = $event)),
        onRefresh: _ctx.onRefresh,
        "loading-text": "Обновляем информацию",
        "loosing-text": "Отпустите для обновления",
        "pulling-text": "Потяните для обновления",
        "success-text": "Успешно обновлено",
        "success-duration": "1500"
      }, {
        default: _withCtx(() => [
          (_ctx.isLoadData && _ctx.notifications.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifications, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "relative mb-3 rounded-md bg-greyLight p-4"
                  }, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, _toDisplayString(item.card_name), 1),
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", null, "Списано: " + _toDisplayString(item.amount), 1),
                          (item.commission_withheld)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, " Отправлено: " + _toDisplayString(_ctx.mathCommission(item.amount, item.commission_withheld)), 1))
                            : _createCommentVNode("", true),
                          (item.commission_withheld)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, " Комиссия: " + _toDisplayString(item.commission_withheld), 1))
                            : _createCommentVNode("", true),
                          (item.partner_bank_name)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(`${item.partner_bank_name}`), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", {
                          class: _normalizeClass([
                  _ctx.validateTransactionStatus(
                    item.status,
                    item.adapter_status,
                    'color',
                  )
                , "flex w-full justify-center rounded-md py-1 px-2 text-sm text-white"])
                        }, _toDisplayString(_ctx.validateTransactionStatus(
                    item.status,
                    item.adapter_status,
                    "text",
                  )), 3),
                        (
                  (item.date_time && _ctx.isActiveContactParent(item.date_time)) ||
                  item.status != 'IN_PROCESSING'
                )
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              onClick: ($event: any) => (_ctx.validateNotComingMoney(item)),
                              class: "cursor-pointer mt-3 flex w-full items-center justify-center rounded-full bg-background py-1 px-2 text-sm text-blue"
                            }, [
                              (
                    item.status === 'PAID' ||
                    item.status === 'IN_PROCESSING' ||
                    item.status === 'ALLOW_TRANSACTION'
                  )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_17, " Не получил "))
                                : _createCommentVNode("", true),
                              (
                    (item.status === 'ERROR' &&
                      (item.adapter_status === 'SUCCESS' ||
                        item.adapter_status === 'NULL' ||
                        item.adapter_status === 'FAILED')) ||
                    item.status === 'BLOCK_TRANSACTION' ||
                    (item.status === 'ERROR' &&
                      item.adapter_status !== 'REVERTED')
                  )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_18, " Почему? "))
                                : _createCommentVNode("", true),
                              (
                    item.status === 'ERROR' &&
                    item.adapter_status === 'REVERTED'
                  )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, " Не вернулось "))
                                : _createCommentVNode("", true)
                            ], 8, _hoisted_16))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_20, _toDisplayString(item.card_number), 1),
                    _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.formatDate(item.date_time)), 1)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue", "onRefresh"]),
      (_ctx.isLoadData && _ctx.count <= 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, " У вас еще нет уведомлений, но они обязательно появятся "))
        : _createCommentVNode("", true),
      (_ctx.shouldShowSupportButtons() && _ctx.showMaxSupport)
        ? (_openBlock(), _createBlock(_component_confirm_modal, {
            key: 2,
            state: _ctx.helpDialogModal,
            "decline-button-text": _ctx.validateDeclineBtnText(),
            htmlDescription: `${
        this.currentNotification?.status === 'ERROR' &&
        (this.currentNotification?.adapter_status === 'SUCCESS' ||
          this.currentNotification?.adapter_status === 'NULL' ||
          this.currentNotification?.adapter_status === 'FAILED')
          ? `${
              this.currentNotification?.adapter_status === 'SUCCESS'
                ? 'Деньги списались с баланса вашего кабинета.'
                : ''
            }
          ${
            this.currentNotification?.adapter_status === 'NULL' ||
            this.currentNotification?.adapter_status === 'FAILED'
              ? 'Деньги с баланса вашего кабинета <strong>НЕ СПИСАЛИСЬ</strong>.\n'
              : ''
          } ${
              this.currentNotification?.status === 'ERROR' &&
              this.currentNotification?.adapter_status === 'SUCCESS'
                ? 'Но на карту не зачислены, разбираемся с проблемой.'
                : ''
            }  ${
              this.currentNotification?.status_description
                ? this.currentNotification?.status_description
                : ''
            }\n ${
              this.currentNotification?.status_payout ===
              'SCORE_NOT_ENOUGH_MONEY'
                ? ''
                : 'Если остались вопросы обратитесь в поддержку.'
            } `
          : ''
      }${
        this.currentNotification?.status === 'ERROR' &&
        this.currentNotification?.adapter_status === 'REVERTED'
          ? `Деньги вернулись на баланс\n в Яндекс Про. ${
              this.currentNotification?.status_description
                ? this.currentNotification?.status_description
                : ''
            }\n Проверьте возврат средств, если возврата не произошло свяжитесь с поддрежкой.\n Поддержка приложения работает с 10 до 22 по МСК.`
          : ''
      } ${
        this.currentNotification?.status === 'BLOCK_TRANSACTION'
          ? 'Транзакция на проверке в «Парке» (у партнера). Скоро статус исзменится, пожалуйста подождите.'
          : ''
      } ${
        this.currentNotification?.status === 'PAID' ||
        this.currentNotification?.status === 'ALLOW_TRANSACTION'
          ? 'Операция прошла успешно. Подождите минимум час и потом пришлите нам историю транзакции из приложения банка.\nЕсли транзакции там нет, выберите способ связи.'
          : ''
      }
       ${
          this.currentNotification?.status === 'IN_PROCESSING'
            ? 'Проведение платежа может затянуться. Пожалуйста подождите минимум час.'
            : ''
        }  `,
            onDecline: _cache[12] || (_cache[12] = ($event: any) => (_ctx.validateDeclineBtn())),
            onConfirm: _cache[13] || (_cache[13] = ($event: any) => (_ctx.handleMaxSupportRequest())),
            onConfirmSecondary: _cache[14] || (_cache[14] = ($event: any) => (_ctx.handleTelegramSupportRequest()))
          }, {
            "confirm-title": _withCtx(() => [...(_cache[33] || (_cache[33] = [
              _createElementVNode("div", { class: "flex items-center" }, [
                _createElementVNode("div", null, "Написать в MAX"),
                _createElementVNode("div", { class: "ml-2 text-2xl" }, [
                  _createElementVNode("img", {
                    src: _imports_0,
                    class: "w-5 h-5"
                  })
                ])
              ], -1)
            ]))]),
            "confirm-secondary-title": _withCtx(() => [...(_cache[34] || (_cache[34] = [
              _createElementVNode("div", { class: "flex items-center" }, [
                _createElementVNode("div", null, "Написать в Telegram"),
                _createElementVNode("div", { class: "ml-2 text-2xl" }, [
                  _createElementVNode("i", { class: "fab fa-telegram-plane" })
                ])
              ], -1)
            ]))]),
            _: 1
          }, 8, ["state", "decline-button-text", "htmlDescription"]))
        : (_ctx.shouldShowSupportButtons())
          ? (_openBlock(), _createBlock(_component_confirm_modal, {
              key: 3,
              state: _ctx.helpDialogModal,
              "decline-button-text": _ctx.validateDeclineBtnText(),
              htmlDescription: `${
        this.currentNotification?.status === 'ERROR' &&
        (this.currentNotification?.adapter_status === 'SUCCESS' ||
          this.currentNotification?.adapter_status === 'NULL' ||
          this.currentNotification?.adapter_status === 'FAILED')
          ? `${
              this.currentNotification?.adapter_status === 'SUCCESS'
                ? 'Деньги списались с баланса вашего кабинета.'
                : ''
            }
          ${
            this.currentNotification?.adapter_status === 'NULL' ||
            this.currentNotification?.adapter_status === 'FAILED'
              ? 'Деньги с баланса вашего кабинета <strong>НЕ СПИСАЛИСЬ</strong>.\n'
              : ''
          } ${
              this.currentNotification?.status === 'ERROR' &&
              this.currentNotification?.adapter_status === 'SUCCESS'
                ? 'Но на карту не зачислены, разбираемся с проблемой.'
                : ''
            }  ${
              this.currentNotification?.status_description
                ? this.currentNotification?.status_description
                : ''
            }\n ${
              this.currentNotification?.status_payout ===
              'SCORE_NOT_ENOUGH_MONEY'
                ? ''
                : 'Если остались вопросы обратитесь в поддержку.'
            } `
          : ''
      }${
        this.currentNotification?.status === 'ERROR' &&
        this.currentNotification?.adapter_status === 'REVERTED'
          ? `Деньги вернулись на баланс\n в Яндекс Про. ${
              this.currentNotification?.status_description
                ? this.currentNotification?.status_description
                : ''
            }\n Проверьте возврат средств, если возврата не произошло свяжитесь с поддрежкой.\n Поддержка приложения работает с 10 до 22 по МСК.`
          : ''
      } ${
        this.currentNotification?.status === 'BLOCK_TRANSACTION'
          ? 'Транзакция на проверке в «Парке» (у партнера). Скоро статус исзменится, пожалуйста подождите.'
          : ''
      } ${
        this.currentNotification?.status === 'PAID' ||
        this.currentNotification?.status === 'ALLOW_TRANSACTION'
          ? 'Операция прошла успешно. Подождите минимум час и потом пришлите нам историю транзакции из приложения банка.\nЕсли транзакции там нет, выберите способ связи.'
          : ''
      }
       ${
          this.currentNotification?.status === 'IN_PROCESSING'
            ? 'Проведение платежа может затянуться. Пожалуйста подождите минимум час.'
            : ''
        }  `,
              onDecline: _cache[15] || (_cache[15] = ($event: any) => (_ctx.validateDeclineBtn())),
              onConfirm: _cache[16] || (_cache[16] = ($event: any) => (_ctx.handleTelegramSupportRequest()))
            }, {
              "confirm-title": _withCtx(() => [...(_cache[35] || (_cache[35] = [
                _createElementVNode("div", { class: "flex items-center" }, [
                  _createElementVNode("div", null, "Написать в Telegram"),
                  _createElementVNode("div", { class: "ml-2 text-2xl" }, [
                    _createElementVNode("i", { class: "fab fa-telegram-plane" })
                  ])
                ], -1)
              ]))]),
              _: 1
            }, 8, ["state", "decline-button-text", "htmlDescription"]))
          : (_openBlock(), _createBlock(_component_confirm_modal, {
              key: 4,
              state: _ctx.helpDialogModal,
              "confirm-button-text": _ctx.validateConfirmBtnText(),
              "decline-button-text": _ctx.validateDeclineBtnText(),
              htmlDescription: `${
        this.currentNotification?.status === 'ERROR' &&
        (this.currentNotification?.adapter_status === 'SUCCESS' ||
          this.currentNotification?.adapter_status === 'NULL' ||
          this.currentNotification?.adapter_status === 'FAILED')
          ? `${
              this.currentNotification?.adapter_status === 'SUCCESS'
                ? 'Деньги списались с баланса вашего кабинета.'
                : ''
            }
          ${
            this.currentNotification?.adapter_status === 'NULL' ||
            this.currentNotification?.adapter_status === 'FAILED'
              ? 'Деньги с баланса вашего кабинета <strong>НЕ СПИСАЛИСЬ</strong>.\n'
              : ''
          } ${
              this.currentNotification?.status === 'ERROR' &&
              this.currentNotification?.adapter_status === 'SUCCESS'
                ? 'Но на карту не зачислены, разбираемся с проблемой.'
                : ''
            }   ${
              this.currentNotification?.status_description
                ? this.currentNotification?.status_description
                : ''
            }\n ${
              this.currentNotification?.status_payout ===
              'SCORE_NOT_ENOUGH_MONEY'
                ? ''
                : 'Если остались вопросы нажмите «Уточнить».\n Поддержка приложения работает с 10 до 22 по МСК.'
            } `
          : ''
      }${
        this.currentNotification?.status === 'ERROR' &&
        this.currentNotification?.adapter_status === 'REVERTED'
          ? `Деньги вернулись на баланс\n в Яндекс Про. ${
              this.currentNotification?.status_description
                ? this.currentNotification?.status_description
                : ''
            }\n Проверьте возврат средств, если возврата не произошло нажмите «Не получил» и свяжитесь с поддрежкой.\n Поддержка приложения работает с 10 до 22 по МСК. `
          : ''
      } ${
        this.currentNotification?.status === 'BLOCK_TRANSACTION'
          ? 'Транзакция на проверке в «Парке» (у партнера). Скоро статус исзменится, пожалуйста подождите.\n Если возникли вопросы нажмите «Уточнить».'
          : ''
      } ${
        this.currentNotification?.status === 'PAID' ||
        this.currentNotification?.status === 'ALLOW_TRANSACTION'
          ? 'Операция прошла успешно. Подождите минимум час и потом пришлите нам историю транзакции из приложения банка.\nЕсли транзакции там нет, дадим номер операции для поиска в вашем банке.'
          : ''
      }
       ${
         this.currentNotification?.status === 'IN_PROCESSING'
           ? 'Проведение платежа может затянуться. Пожалуйста подождите минимум час.\n Если возникли вопросы нажмите «Уточнить».'
           : ''
       }  `,
              onDecline: _cache[17] || (_cache[17] = ($event: any) => (_ctx.validateDeclineBtn())),
              onConfirm: _cache[18] || (_cache[18] = ($event: any) => (_ctx.validateConfirmBtn()))
            }, null, 8, ["state", "confirm-button-text", "decline-button-text", "htmlDescription"])),
      _createVNode(_component_status_modal, {
        state: _ctx.statusModalDialog,
        "button-text": "Понял",
        description: _ctx.statusModalText,
        type: "warning",
        onConfirm: _cache[19] || (_cache[19] = ($event: any) => (_ctx.statusModalDialog = false))
      }, null, 8, ["state", "description"]),
      _createVNode(_component_status_modal, {
        state: _ctx.supportModalDialog,
        "button-text": "Отмена",
        description: 'Для связи с «Парком» вы можете:',
        type: "warning",
        onConfirm: _cache[20] || (_cache[20] = ($event: any) => (_ctx.supportModalDialog = false)),
        onWa: _cache[21] || (_cache[21] = ($event: any) => (_ctx.sendWhatsAppPark())),
        onTm: _cache[22] || (_cache[22] = ($event: any) => (_ctx.sendTelegramPark())),
        onMax: _cache[23] || (_cache[23] = ($event: any) => (_ctx.sendMaxPark())),
        onOpenEmail: _cache[24] || (_cache[24] = ($event: any) => (_ctx.sendEmailPark())),
        isSupportModal: true,
        "wa-support": _ctx.currentCabinetSupportLinks.wa_support,
        "tm-support": _ctx.currentCabinetSupportLinks.tm_support,
        "max-support": _ctx.currentCabinetSupportLinks.max_support,
        "email-support": _ctx.currentCabinetSupportLinks.email_support
      }, null, 8, ["state", "wa-support", "tm-support", "max-support", "email-support"]),
      (!_ctx.isLoadData)
        ? (_openBlock(), _createBlock(_component_notification_page_skeleton, { key: 5 }))
        : _createCommentVNode("", true),
      _cache[36] || (_cache[36] = _createElementVNode("div", { class: "flex justify-center items-center py-4" }, [
        _createElementVNode("div", { class: "animate-spin rounded-full h-8 w-8 border-b-2 border-[#FFD92E]" })
      ], -1))
    ]),
    _: 1
  }))
}